import parse from "html-react-parser";
import VideoModal from "../VideoModal";

export default function Hero({
  title,
  subTitle,
  bgUrl,
  imgUrl,
  videoBtnText,
  videoUrl,
  infoList,
  btnText,
  btnUrl,
}) {
  return (
    <section className="cs_hero cs_style_1">
      <div
        className="cs_hero_wrap cs_bg_filed"
        style={{ backgroundImage: `url(${bgUrl})` }}
      >
        {/* Main Content */}
        <div className="container">
          <img src={imgUrl} alt="Hero" className="cs_hero_img" />

          {/* Title & SubTitle */}
          <div>
            <div>
              <h1 className="cs_hero_title cs_fs_94 bg-[rgba(255,255,255,0.6)] p-[10px] rounded-[30px]">
                {parse(title)}
              </h1>
              <p className="cs_hero_subtitle cs_fs_20 cs_heading_color lg:ml-[0] md:ml-[125px] sm:ml-[50px] lg:mt-[0]">
                {parse(subTitle)}
              </p>
            </div>

            <div className="cs_hero_btn_wrap mb-4">
              <VideoModal
                videoUrl={videoUrl}
                videoBtnText={videoBtnText}
                variant="cs_heading_color"
              />
            </div>

            {/* Button section */}
            {/* <div className="md:grid grid-cols-3 gap-4 flex flex-col items-center w-full">
              <div className="flex items-center flex-col bg-white/50 backdrop-blur-sm shadow-md shadow-gray-300 p-3 rounded-xl min-w-full">
                <p className=" text-[#274760] text-sm text-center md:text-lg">
                  Conditions & Eligibility for the BRT 2025-2026
                </p>
                <a
                  href="https://career.nhwm.in/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="border-1 border-[#307bc4] px-3 py-2 rounded-xl hover:bg-[#307bc4]/80 transition-colors hover:text-white text-[#274760] text-sm duration-300 ease-in-out"
                >
                  Read Here
                </a>
              </div>
              <div className="flex items-center flex-col bg-white/50 backdrop-blur-sm shadow-md shadow-gray-300 p-3 rounded-xl min-w-full">
                <p className=" text-[#274760] text-sm text-center md:text-lg">
                  Online Application for BRT 2025-2026 is in Progress
                </p>
                <a
                  href="/register"
                  className="border-1 border-[#307bc4] px-3 py-2 rounded-xl hover:bg-[#307bc4]/80 transition-colors hover:text-white text-[#274760] text-sm duration-300 ease-in-out"
                >
                  Register for Applying
                </a>
              </div>
              <div className="flex items-center flex-col bg-white/50 backdrop-blur-sm shadow-md shadow-gray-300 p-3 rounded-xl min-w-full">
                <p className=" text-[#274760] text-sm md:text-lg">
                  Already Registered ?
                </p>
                <a
                  href="/signup"
                  className="border-1 border-[#307bc4] px-3 py-2 rounded-xl hover:bg-[#307bc4]/80 transition-colors hover:text-white text-[#274760] text-sm duration-300 ease-in-out"
                >
                  Login
                </a>
              </div>
            </div> */}
          </div>

          {/* Info Cards */}
          <div className="cs_hero_info_wrap cs_shadow_1 cs_white_bg cs_radius_15 mt-[40px]">
            {infoList.map((item, index) => (
              <div className="cs_hero_info_col" key={index}>
                <div className="cs_hero_info d-flex align-items-center">
                  <div className="cs_hero_info_icon cs_center rounded-circle cs_accent_bg">
                    <img src={item.iconUrl} alt="Icon" />
                  </div>
                  <div className="cs_hero_info_right flex flex-col">
                    <h3 className="cs_hero_info_title cs_semibold">
                      {item.title}
                    </h3>
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cs_hero_info_subtitle cs_fs_20"
                    >
                      {item.subTitle}
                    </a>
                    <a
                      href={item.href2}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cs_hero_info_subtitle cs_fs_20"
                    >
                      {item.subTitle2}
                    </a>
                    <a
                      href={item.href3}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cs_hero_info_subtitle cs_fs_20"
                    >
                      {item.subTitle3}
                    </a>
                  </div>
                </div>
              </div>
            ))}
            
            <div className="cs_hero_info_col space-x-5">
              <span className="text-xl font-bold text-[#42679e]">Want to Unlock Every Benefit We Offer ?</span>
              <a
                href="/register"
                className="cs_btn cs_style_1"
              >
                
                <span>{btnText}</span>
                <i>
                  <img src="/images/icons/arrow_white.svg" alt="Icon" />
                  <img src="/images/icons/arrow_white.svg" alt="Icon" />
                </i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
